import { forwardRef, HTMLAttributes } from 'react'

import { useStore } from '@/contexts/store'

import { cn } from '@/lib/utils'

export type BurgerProps = HTMLAttributes<HTMLButtonElement> &
  Partial<{
    open: boolean
    onClick: () => void
  }>

const Burger = forwardRef<HTMLButtonElement, BurgerProps>(
  ({ open, className, onClick, ...props }, ref) => {
    const { strings } = useStore()

    return (
      <button
        onClick={onClick}
        ref={ref}
        className={cn(
          'group',
          'size-[48px]',
          'relative z-10 text-text-primary-light dark:text-text-primary-light',
          className
        )}
        {...props}
        aria-label={strings?.labels?.menu || 'Menu'}
        aria-expanded={open}
        aria-controls="main-menu"
      >
        <span
          className={cn(
            'ease-in-out absolute inset-0 transition-transform duration-300 group-hover:scale-[0.95]'
          )}
        >
          <span
            className={cn(
              'block h-[1.5px] w-[24px] bg-background-frame-dark dark:bg-surface-primay-invert-light',
              'absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]',
              'transition-[width,transform] duration-500 ease-in-out-cubic',
              open ? 'w-[17px] rotate-[135deg]' : 'translate-y-[-3px]'
            )}
          />
          <span
            className={cn(
              'block h-[1.5px] w-[24px] bg-background-frame-dark dark:bg-surface-primay-invert-light',
              'absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]',
              'transition-[width,transform] duration-500 ease-in-out-cubic',
              open ? 'w-[17px] -rotate-[135deg]' : 'translate-y-[3px]'
            )}
          />
        </span>
      </button>
    )
  }
)

export default Burger
